export default {
    form: () => {
        return {
            name: "Krijo Sektor",
            submit: {
                label: "Krijo",
                action: "submitSector",
            },
            fields: [
                [
                    {
                        value: "",
                        name: "name",
                        label: "Emri",
                        type: "text-field",
                        style: "flex-grow: 0.6",
                        required: true,
                        required_text: "Kjo fushe eshte e detyrueshme",
                    },
                ],
            ],
        };
    },
};
